import React, {useState, useEffect} from 'react';
import {motion} from 'framer-motion';
import {Link} from "react-router-dom";
import ReactDOM from "react-dom";
import './Glass_NavBar.css';
import { useTheme } from '../../../G&CSCM/Core/useTheme';

const Glass_NavBar: React.FC = () => {
    const { config, getComponentParams, isModuleEnabled } = useTheme();
    const params = getComponentParams('Glass_NavBar') as { tinted?: boolean };
    
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu = () => setIsOpen(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);

    }, []);
    
    const tinted = params.tinted ?? false;
    
    if (!isModuleEnabled('Glass_NavBar')) {
        return (<></>)
    }
    if (config.PagesList.filter(page => page.pageUrl && page.pageUrl !== "/" && page.InNavBar).length <= 0) {
        return (
            <>
                <motion.nav
                    className={`${tinted ? 'Glass-NavBar' : 'Glass-NavBar-NTinted'} ${isOpen ? 'Glass-NavBar-open' : ''}`}
                    initial={{y: -100, opacity: 0}}
                    animate={{y: 0, opacity: 1}}
                    transition={{duration: 1, ease: 'easeOut'}}

                >
                    <div className="Glass-NavBar-No-Link-content">
                            <Link className="Glass-NavBar-title Glass-NavBar-a" to="/" data-discover="true" onClick={closeMenu}>{config.SiteName}</Link>
                    </div>
                </motion.nav>
            </>
        );
    }else if(config.PagesList.filter(page => page.pageUrl && page.pageUrl !== "/" && page.InNavBar).length >= 5){
        return (
            <>
                <motion.nav
                    className={`${tinted ? 'Glass-NavBar' : 'Glass-NavBar-NTinted'} ${isOpen ? 'Glass-NavBar-open' : ''}`}
                    initial={{y: -100, opacity: 0}}
                    animate={{y: 0, opacity: 1}}
                    transition={{duration: 1, ease: 'easeOut'}}
                >
                    <div className="Glass-NavBar-content">
                        <div className="Glass-NavBarr-title">
                            <Link className="Glass-NavBar-title Glass-NavBar-a" to="/" data-discover="true" onClick={closeMenu}>{config.SiteName}</Link>
                        </div>

                        {/* Menu principal : affiche uniquement les 3 premiers liens */}
                        {!isMobile && (
                            <ul className="Glass-NavBar-menu Glass-NavBar-menu-5">
                                {config.PagesList
                                    .filter(page => page.pageUrl && page.pageUrl !== "/" && page.InNavBar)
                                    .slice(0, 3) // garder uniquement les 3 premiers
                                    .map((page, idx) => (
                                        <li key={idx}>
                                            <Link className="Glass-NavBar-a" to={page.pageUrl} onClick={closeMenu}>
                                                {page.pageName}
                                            </Link>
                                        </li>
                                    ))}
                                <div className={`Glass-NavBar-burger Glass-NavBar-burger-5 ${isOpen ? 'Glass-NavBar-open' : ''}`} onClick={toggleMenu}>
                                    <div className="Glass-NavBar-line"></div>
                                    <div className="Glass-NavBar-line"></div>
                                    <div className="Glass-NavBar-line"></div>
                                </div>
                            </ul>
                        )}
                        {isMobile && (
                            <div className={`Glass-NavBar-burger ${isOpen ? 'Glass-NavBar-open' : ''}`}
                                 onClick={toggleMenu}>
                                <div className="Glass-NavBar-line"></div>
                                <div className="Glass-NavBar-line"></div>
                                <div className="Glass-NavBar-line"></div>
                            </div>
                        )}
                    </div>
                </motion.nav>

                {/* Menu mobile + les liens après les 3 premiers */}
                {isOpen &&
                    ReactDOM.createPortal(
                        <ul className={
                            !isMobile
                                ? `${tinted ? 'Glass-NavBar-menu-mobile' : 'Glass-NavBar-menu-mobile-NTinted'} 
                                    ${tinted ? 'Glass-NavBar-menu-mobile-5' : 'Glass-NavBar-menu-mobile-5-NTinted'}`
                                : ''
                        }
                        >
                            {config.PagesList
                                .filter(page => page.pageUrl && page.pageUrl !== "/" && page.InNavBar)
                                .slice(3) // garder uniquement les suivants
                                .map((page, idx) => (
                                    <li key={idx}>
                                        <Link className="Glass-NavBar-a" to={page.pageUrl} onClick={closeMenu}>
                                            {page.pageName}
                                        </Link>
                                    </li>
                                ))}
                        </ul>,
                        document.body
                    )
                }
                {isOpen && isMobile &&
                    ReactDOM.createPortal(
                        <ul className={`${tinted ? 'Glass-NavBar-menu-mobile' : 'Glass-NavBar-menu-mobile-NTinted'} ${tinted ? 'Glass-NavBar-menu-mobile-5' : 'Glass-NavBar-menu-mobile-5-NTinted'}`}>
                            {config.PagesList
                                .filter(page => page.pageUrl && page.pageUrl !== "/" && page.InNavBar)// garder uniquement les suivants
                                .map((page, idx) => (
                                    <li key={idx}>
                                        <Link className="Glass-NavBar-a" to={page.pageUrl} onClick={closeMenu}>
                                            {page.pageName}
                                        </Link>
                                    </li>
                                ))}
                        </ul>,
                        document.body
                    )
                }
            </>
        );
    }else{
        return (
            <>
                <motion.nav
                    className={`${tinted ? 'Glass-NavBar' : 'Glass-NavBar-NTinted'} ${isOpen ? 'Glass-NavBar-open' : ''}`}
                    initial={{y: -100, opacity: 0}}
                    animate={{y: 0, opacity: 1}}
                    transition={{duration: 1, ease: 'easeOut'}}
                >
                    <div className="Glass-NavBar-content">
                        <div className="Glass-NavBarr-title">
                            <Link className="Glass-NavBar-title Glass-NavBar-a" to="/" data-discover="true" onClick={closeMenu}>{config.SiteName}</Link>
                        </div>

                        {!isMobile && (
                            <ul className="Glass-NavBar-menu">
                                {config.PagesList.filter(page => page.pageUrl && page.pageUrl !== "/" && page.InNavBar).map((page) => (
                                    <li><Link className="Glass-NavBar-a" to={page.pageUrl}
                                              onClick={closeMenu}>{page.pageName}</Link></li>
                                ))}
                            </ul>
                        )}

                        {isMobile && (
                            <div className={`Glass-NavBar-burger ${isOpen ? 'Glass-NavBar-open' : ''}`}
                                 onClick={toggleMenu}>
                                <div className="Glass-NavBar-line"></div>
                                <div className="Glass-NavBar-line"></div>
                                <div className="Glass-NavBar-line"></div>
                            </div>
                        )}
                    </div>
                </motion.nav>

                {/* Menu mobile rendu dans <body> */}
                {isOpen && isMobile &&
                    ReactDOM.createPortal(
                        <ul className={`${tinted ? 'Glass-NavBar-menu-mobile' : 'Glass-NavBar-menu-mobile-NTinted'}`}>
                            {config.PagesList.filter(page => page.pageUrl && page.pageUrl !== "/" && page.InNavBar)
                                .map((page) => (
                                <li><Link className="Glass-NavBar-a" to={page.pageUrl}
                                          onClick={closeMenu}>{page.pageName}</Link></li>
                            ))}
                        </ul>,
                        document.body
                    )
                }
            </>
        );
    }
}
export default Glass_NavBar;
